/**
 * Reading a refused invoice submit (spec §1.1).
 *
 * A line can carry several invoices now, so "you have already invoiced this
 * line" is no longer a refusal — that is the feature. What the server still
 * refuses is the same amount submitted again while the first one is unpaid,
 * which is what a double submission looks like.
 *
 * It answers 400 with a code and no prose. Left alone that reaches the
 * creator as "Something went wrong. Please try again.", and trying again is
 * the one thing that cannot work.
 *
 * Pure.
 */

export const DUPLICATE_CODE = 'duplicate_invoice';

const FALLBACK = 'Something went wrong. Please try again.';

/** The clashing invoice as `{id}`, or null when this is a different refusal. */
export function duplicateInvoice(error) {
  const body = (error || {}).fieldErrors || {};
  if (body.code !== DUPLICATE_CODE) return null;

  const id = body.duplicate_of;
  return { id: id === undefined || id === null ? null : id };
}

/** What to show the creator. */
export function submitErrorMessage(error) {
  const clash = duplicateInvoice(error);
  if (clash) {
    // Read from the body rather than from error.message, which parseError
    // fills with the generic retry line when the server sent no prose --
    // and inviting a retry is the one thing that cannot work here.
    const sent = ((error || {}).fieldErrors || {}).message;
    if (sent && String(sent).trim()) return String(sent).trim();

    return clash.id
      ? `You have already raised invoice #${clash.id} for this amount and it has not been paid yet. Check your invoices before raising another.`
      : 'You have already raised an invoice for this amount and it has not been paid yet. Check your invoices before raising another.';
  }

  return (error && error.message) || FALLBACK;
}
